// ファイルアップロード
import commonClass from './commonClass';

export default class uploadFileClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$prt = $('.c-fileupload');
    this._$photoTmp = $('.c-fileupload_tmp');

    this._prt = '.c-fileupload';
    this._photoTmp = '.c-fileupload_tmp';
    this._fileUpload = '.js-file';
    this._fileInput = '.js-file-input';
    this._fileDrop = '.c-fileupload_drop';
    this._filePrv = '.c-fileupload_prev';
    this._fileDel = '.js-file-del';
    this._fNameInput = '.js-fname-input';
    this._fileNotice = '.c-fileupload_notice';
    this._fileBody = '.c-fileupload_body';
    this._fileOpenPrev = '.js-file-openPrev';
    this._fileRequire = '.js-file-require';
    this._files = {};
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    if (cls._$prt.length) {
      // ファイル選択ボタン
      $(document).on('click', cls._fileUpload, function () {
        $(this).closest(cls._prt).find(cls._fileInput).click();
        return false;
      });

      // ファイルのプレビュー
      $(document).on('change', cls._fileInput, function () {
        var me = this;
        var isSingle = $(me).hasClass('is-single');
        var isNotice = $(me).hasClass('is-notice');
        var maxFileNum = parseInt($(me).attr('max-file-num')) || 0;
        var fileKey = $(me).attr('file-key');

        if (fileKey && $(me).prev().find(cls._filePrv).find('li').length === 0) {
          cls._files[fileKey] = [];
        }

        if (isSingle) {
          cls._prev(this.files[0], me, isSingle);
        }
        if (isNotice) {
          var $body = $(this).parents(cls._fileBody)
          $body.find(cls._fileNotice).show();
        }
        else {
          for (var i = 0; i < this.files.length; i++) {
            if (fileKey && maxFileNum > 0 && cls._files[fileKey].length >= maxFileNum) {
              window.alert(maxFileNum + '個を越えて選択出来ません。');
              break;
            }
            if (fileKey) {
              cls._files[fileKey].push(this.files[i]);
            }
            cls._prev(this.files[i], me, isSingle);
          }
        }
      });

      $(document).on('click', cls._fileInput, function (e) {
        e.target.value = "";
      });

      // ファイルの削除
      $(document).on('click', cls._fileDel, function (e) {
        var $body = $(this).parents(cls._fileBody)
        var isNotice = $body.find(cls._fileInput).hasClass('is-notice');
        var fileKey = $body.find(cls._fileInput).attr('file-key');

        // ファイル名削除
        // 2021/01/07 削除方法変更
        var $fnameInput = $(e.target).closest(cls._prt).find(cls._fNameInput);
        // パス表示のインプットが存在すれば実行
        if ($fnameInput.length > 0) {
          $fnameInput.val("").change();
        }

        /*
         * 2021/01/07 削除方法変更
        var $fnameInput = $(e.target).parents('form').find(cls._fNameInput);
        // パス表示のインプットが存在すれば実行
        if ($fnameInput.length > 0) {
          $(e.target).parents('form').find(cls._fNameInput).val("").change();
        }
        */

        //hiddenのid削除　2021/01/07
        var $pic_id = $(e.target).closest(cls._prt).find('.js-picureid');
        if ($pic_id.length > 0) {
            $pic_id.val("").change();
        }

        // 補足事項が存在すれば実行
        if (isNotice) {
          $body.find(cls._fileNotice).hide();
        }

        //プレビューエリアを消す　2020/09/17
        var cnt = $(e.target).closest('.c-fileupload_prev').find('.c-fileupload_pic').length;
        // console.log($(e.target).closest('.c-fileupload_prev').find('.c-fileupload_pic').length)
        if (cnt <= 1) {
          var $prevArea = $(cls._fileOpenPrev).closest('.c-frm_row').next().find(cls._fileDrop);
          $prevArea.toggleClass('is-hide');
        }

        if (fileKey) {
          var index = $(e.target).parent().prevAll().length;
          cls._files[fileKey].splice(index, 1);
        }

        // サムネ削除
        $(e.target).parent().remove();
      });

      // プレビューエリア開閉
      $(document).on('click', cls._fileOpenPrev, function () {
        var $prevArea = $(this).closest('.c-frm_row').next().find(cls._fileDrop);
        $prevArea.children().children().remove();//プレビューエリアを消す　2020/12/07
        $prevArea.toggleClass('is-hide')
        return false;
      });

      // // 画像編集モーダル
      // // 画像編集モーダルが存在、かつimgにモーダル指定のdata属性があれば発火
      // var $editImageModal = $('.c-modal[data-mdtrg="edit_image"]')
      // $(document).on('click', '.c-fileupload_pic img', function () {
      //   if ($editImageModal.length > 0) {
      //     APP.modal._open($(this));
      //   }
      //   return false;
      // });

    }
  }
  // プレビューリストを生成
  _prev(files, me, isSingle) {
    var cls = this;

    if ($(me).attr('no-load') !== undefined) {
      // ファイル名だけセット
      var fnameInputs = $(me).parents('.c-frm_row').prev().find(cls._fNameInput);
      if (fnameInputs.length > 0) {
        fnameInputs.val(files.name).change();
        fnameInputs.addClass('has-val');
      }
      return;
    }

    var fr = new FileReader();
    fr.onload = function () {
      var $prevPath = $(me).prev().find(cls._filePrv);
      var $fnameInputPath = $(me).parents('.c-frm_row').prev().find(cls._fNameInput);
      var img = $('<img>').attr({
        'src': _.endsWith(_.toLower(files.name), '.pdf') ? '/img/pdf_icon.png' : fr.result,
        'data-mdname': 'edit_image',
        'class': 'prev-img'
      });
      var spnfname = $('<span>').attr({
        'style': 'max-width: 100px; word-wrap: break-word; font-size: x-small;',
        'class': 'c-frm_head_lbl'
      });
      var fname = files.name;
      var isCustom = $(me).parents(cls._$prt).hasClass('custom-prev');

      // ファイル名表示用のテキストボックスが存在すれば実行
      if ($fnameInputPath.length > 0) {
        $fnameInputPath.val(fname).change();
        $fnameInputPath.addClass('has-val');
      }

      // テンプレートのコピー
      var $copyTmp = cls._$photoTmp.children('.c-fileupload_pic');

      // 画像スニペット用プレビューの場合
      if (isCustom) {
        // テンプレートのコピー
        $copyTmp = $(me).parents(cls._$prt).next(cls._photoTmp).children();
      }

      // シングル画像の場合
      if (isSingle) {
        if ($prevPath.find('li').length !== 0) {
          $prevPath.find('li').remove();
        }
      }

      $copyTmp.clone(true).appendTo($prevPath);

      // 画像スニペット用プレビュー
      if (isCustom) {
        // 画像を追加
        $prevPath.find('li').last().find('.snp-img_prv_itm_img').append(img);
        // ファイル名を追加
        $prevPath.find('li').last().find('.snp_fname').text(fname);
      } else {
        // 画像を追加
        spnfname.html(fname);
        $prevPath.find('li').last().append(img);
        $prevPath.find('li').last().append("<br>");
        $prevPath.find('li').last().append(spnfname);
      }

      var $prevArea = $(me).siblings(cls._fileDrop);
      if ($prevArea.hasClass('is-hide')) {
        $prevArea.removeClass('is-hide');
      }
    };
    fr.readAsDataURL(files);
  }
}